/** `12.345.678/0001-90` — the only form a Brazilian buyer recognises at a glance. */
export function formatTaxId(value: string): string {
  const digits = value.replace(/\D/gu, '');
  if (digits.length !== 14) {
    return value;
  }
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
}
